import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";

// 代行入力依頼参照API
// API仕様書_代行者
import {
  IAPI_AGE007_Request,
  IAPI_AGE007_Response,
} from "../../../type/apiType";

// 代行入力依頼更新API
// API仕様書_代行者
import {
  IAPI_AGE009_Request,
  IAPI_AGE009_Response,
} from "../../../type/apiType";

// 代行入力依頼参照API
// API仕様書_代行者
const httpIAPI_AGE007 = async (
  param: IAPI_AGE007_Request
): Promise<IAPI_AGE007_Response> => {
  let res = await http.post(ApiUrl.API_AGE007, {
    ...param,
  });
  return res.data;
};

// 代行入力依頼更新API
// API仕様書_代行者
const httpIAPI_AGE009 = async (
  param: IAPI_AGE009_Request
): Promise<IAPI_AGE009_Response> => {
  let res = await http.post(ApiUrl.API_AGE009, {
    ...param,
  });
  return res.data;
};

export { httpIAPI_AGE007, httpIAPI_AGE009 };
